<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [hideHeader]="true"
   [pagingCallState]="pagingCallState"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
>
   <ndt-register-quick-filter>
      <ndt-call-history-filter
         [quickFilters]="registerOptions"
         [isSystemUser]="isSystemUser"
         (logQuickFilterChanged)="onFilterChange($event)"
      ></ndt-call-history-filter>
   </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="startDate" [width]="5">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="startDate-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Desc"
               sortField="startTime"
               >Date/Time<mat-icon class="mat-icon-sort">{{ getSort('startTime') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let callLogs" [ngClass]="{ highlighted: callLogs?.callRate > 0 && isSystemUser }">
               <a (click)="onOpenDialog(callLogs)">
                  {{ callLogs.startTime | date : 'MM/dd/yyyy hh:mm:ss aa' }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDirection" [width]="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="callDirection-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="callDirectionTypeName"
               >In/Out<mat-icon class="mat-icon-sort">{{ getSort('callDirectionTypeName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let callLogs" [ngClass]="{ highlighted: callLogs?.callRate > 0 && isSystemUser }">
               <a (click)="onOpenDialog(callLogs)">
                  {{ callLogs.callDirectionTypeId | addSpaces }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callSource" [width]="5">
            <th lcs-header-cell *lcsHeaderCellDef id="source-column-header">From</th>
            <td lcs-cell *lcsCellDef="let callLogs" [ngClass]="{ highlighted: callLogs?.callRate > 0 && isSystemUser }">
               <a (click)="onOpenDialog(callLogs)">
                  {{ callLogs.callSource | formatPhoneNumbers }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDestination" [width]="5">
            <th lcs-header-cell *lcsHeaderCellDef id="destination-column-header">To</th>
            <td lcs-cell *lcsCellDef="let callLogs" [ngClass]="{ highlighted: callLogs?.callRate > 0 && isSystemUser }">
               <a (click)="onOpenDialog(callLogs)">
                  {{ callLogs.callDestination | formatPhoneNumbers }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="destinationNumber" [width]="3">
            <th lcs-header-cell *lcsHeaderCellDef id="number-dialed-column-header">Dialed</th>
            <td lcs-cell *lcsCellDef="let callLogs" [ngClass]="{ highlighted: callLogs?.callRate > 0 && isSystemUser }">
               <a (click)="onOpenDialog(callLogs)">
                  {{
                     (callLogs.callDirectionTypeId == 'Inbound' && callLogs.phoneNumber
                        ? callLogs.phoneNumber
                        : callLogs.originalDestinationNumber
                     ) | formatPhoneNumbers
                  }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDisposition" [width]="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="disposition-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="getOrderingOption(orderingOptions, 'callDispositionTypeName')"
               sortField="callDispositionTypeName"
               >Disposition<mat-icon class="mat-icon-sort">{{ getSort('callDispositionTypeName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let callLogs" [ngClass]="{ highlighted: callLogs?.callRate > 0 && isSystemUser }">
               <a (click)="onOpenDialog(callLogs)">
                  {{ callLogs.callDispositionTypeId === 'QueueCallBack' ? 'Callback' : callLogs.callDispositionTypeId }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDuration" [width]="3">
            <th class="header-align-right" lcs-header-cell *lcsHeaderCellDef id="duration-column-header">Duration</th>
            <td lcs-cell *lcsCellDef="let callLogs" [ngClass]="{ highlighted: callLogs?.callRate > 0 && isSystemUser }">
               <a class="text-align-right" (click)="onOpenDialog(callLogs)">
                  {{ callLogs.startTime | durationFormat : callLogs.endTime }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="detail" [width]="1">
            <th lcs-header-cell *lcsHeaderCellDef id="duration-column-header"></th>
            <td lcs-cell *lcsCellDef="let callLogs" [ngClass]="{ highlighted: callLogs?.callRate > 0 && isSystemUser }">
               <button
                  type="button"
                  mat-button
                  matTooltip="Info"
                  aria-label="Details Info"
                  id="extension-detail-info"
                  [matMenuTriggerFor]="callLogMenu"
                  ><mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #callLogMenu="matMenu">
                  <button mat-menu-item type="button" id="call-history-details" (click)="onOpenDialog(callLogs)">
                     Details
                  </button>
                  @if (callLogs.callRecordingFile && callLogs.startTime >= hideRecordingDate &&
                  !callLogs.isPhoneCallThatWentDirectlyToSourceExtension) {
                  <button mat-menu-item type="button" id="call-history-details" (click)="onListen(callLogs)">
                     Listen
                  </button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
